"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = require("@floating-ui/react");
const compose_refs_1 = require("@uxf/core-react/utils/compose-refs");
const cx_1 = require("@uxf/core/utils/cx");
const react_2 = __importStar(require("react"));
const use_tooltip_1 = require("./use-tooltip");
const STATIC_SIDES = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
};
exports.Tooltip = (0, react_2.forwardRef)(({ children, className, content, style, ...options }, ref) => {
    var _a, _b, _c;
    const arrowRef = (0, react_2.useRef)(null);
    const tooltip = (0, use_tooltip_1.useTooltip)({ arrowRef, ...options });
    const arrowX = (_a = tooltip.middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x;
    const arrowY = (_b = tooltip.middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.y;
    const staticSide = STATIC_SIDES[(_c = tooltip.placement.split("-").at(0)) !== null && _c !== void 0 ? _c : "top"];
    const stableRef = (0, react_2.useMemo)(() => (0, compose_refs_1.composeRefs)(ref, tooltip.refs.setReference, children.ref), [ref, tooltip.refs.setReference, children]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        (0, react_2.cloneElement)(children, tooltip.getReferenceProps({
            ref: stableRef,
            ...children.props,
            "data-state": tooltip.open ? "open" : "closed",
        })),
        tooltip.open && (react_2.default.createElement(react_1.FloatingPortal, null,
            react_2.default.createElement("div", { ...tooltip.getFloatingProps({
                    className: (0, cx_1.cx)("uxf-tooltip", className),
                    ref: tooltip.refs.setFloating,
                    style: {
                        ...tooltip.floatingStyles,
                        ...style,
                    },
                }) },
                react_2.default.createElement("div", { className: "uxf-tooltip__arrow", ref: arrowRef, style: {
                        height: "16px",
                        left: arrowX !== undefined ? `${arrowX}px` : "",
                        position: "absolute",
                        top: arrowY !== undefined ? `${arrowY}px` : "",
                        transform: "rotate(45deg)",
                        width: "16px",
                        [staticSide]: "-6px",
                    } }),
                content)))));
});
exports.Tooltip.displayName = "UxfUiTooltip";
